import tw, { styled } from 'twin.macro'

export const FieldLabel = tw.label`
  block
  font-semibold
  font-brand
  text-sm-brand
  text-default-neutral
`

export const FieldCornerHint = tw.span`
  font-brand
  text-sm-brand
  text-gray-500
  text-right
  select-none
`

export const FieldDescription = tw.span`
  block
  font-brand
  text-sm-brand
  text-gray-400
`

export const FieldCaption = styled.span<{ error?: unknown }>(({ error }) => [
  tw`block mt-2 text-sm-brand font-brand`,
  error ? tw`text-red-600` : tw`text-gray-500`,
])

export const FieldFrozenValue = tw.span`
  text-gray-500
  leading-6
  font-brand
  text-base-brand
`
